import { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';
import { App as CapApp } from '@capacitor/app';
import { ArrowUpCircle } from 'lucide-react';

// Compara versiones tipo "1.2.0" / "1.10.3". Devuelve <0, 0 o >0.
function compararVersiones(a, b) {
  const pa = String(a).split(/[^\d]+/).filter(Boolean).map(Number);
  const pb = String(b).split(/[^\d]+/).filter(Boolean).map(Number);
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const x = pa[i] || 0;
    const y = pb[i] || 0;
    if (x !== y) return x - y;
  }
  return 0;
}

// Gate de actualización forzada. Solo aplica a la app NATIVA (en navegador/PWA
// la web siempre está actualizada). Lee la versión del binario instalado y la
// compara contra la mínima publicada en /app-version.json; si está por debajo,
// muestra una pantalla bloqueante con botón a la tienda.
//
// Para forzar una actualización: sube el nuevo binario a la tienda y LUEGO sube
// `minVersion` en app-version.json (nunca por encima de lo que ya está publicado,
// o dejarías a todos sin poder actualizar).
export default function ActualizacionGate() {
  const [bloqueo, setBloqueo] = useState(null); // { url, version, min }

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return; // web siempre fresca

    (async () => {
      try {
        const info = await CapApp.getInfo(); // { version, build, ... }
        const plataforma = Capacitor.getPlatform(); // 'android' | 'ios'
        const res = await fetch(`/app-version.json?t=${Date.now()}`, {
          cache: 'no-store',
        });
        if (!res.ok) return;
        const cfg = await res.json();
        const c = cfg?.[plataforma];
        if (!c?.minVersion) return;
        if (compararVersiones(info.version, c.minVersion) < 0) {
          setBloqueo({ url: c.url, version: info.version, min: c.minVersion });
        }
      } catch (e) {
        // fail-open: si no se puede verificar (offline, etc.), NO bloquear
        console.warn('No se pudo verificar la versión de la app:', e);
      }
    })();
  }, []);

  if (!bloqueo) return null;

  return (
    <div
      className="fixed inset-0 z-[300] bg-base-100 flex flex-col items-center justify-center text-center p-8"
      style={{
        paddingTop: 'max(2rem, env(safe-area-inset-top))',
        paddingBottom: 'max(2rem, env(safe-area-inset-bottom))',
      }}
    >
      <div className="w-20 h-20 rounded-full bg-primary/15 flex items-center justify-center mb-6">
        <ArrowUpCircle className="w-10 h-10 text-primary" />
      </div>
      <h1 className="text-2xl font-bold text-base-content mb-2">
        Actualiza la aplicación
      </h1>
      <p className="text-base-content/60 max-w-sm mb-8">
        Hay una nueva versión disponible con mejoras importantes. Para seguir
        usando Carnet Plus Docente necesitas actualizar.
      </p>
      <a
        href={bloqueo.url}
        target="_blank"
        rel="noreferrer"
        className="btn btn-primary btn-wide"
      >
        Actualizar ahora
      </a>
      <p className="text-xs text-base-content/30 mt-6">
        Versión instalada {bloqueo.version}
      </p>
    </div>
  );
}
